<template>
  <dir class="center-cmp">
    <div class="cc-header">
      <dv-decoration-1 style="width:200px;height:50px;" />
      <div style="margin: 0 auto;">
        <div style="margin: 0 auto;text-align:center">设备状态</div>
         <div style="margin: 0 auto;">Machine Status</div>
      </div>
      <dv-decoration-1 style="width:200px;height:50px;" />
    </div>



    <div class="Echarts">
      <div id="main" style="width:100%; height:230px;"></div>
    </div>
    
    <div class="legend" style="height:40px">
      <div class="void"></div>
      <div class="legenditem">
        <svg t="1672910618198" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3532" id="mx_n_1672910618201" data-spm-anchor-id="a313x.7781069.0.i2" width="32" height="90"><path d="M158.3104 589.824h707.3792a10.8544 10.8544 0 0 0 10.8544-10.8544v-133.98016a10.8544 10.8544 0 0 0-10.8544-10.8544H155.648a8.192 8.192 0 0 0-8.192 8.192v136.56064a10.8544 10.8544 0 0 0 10.8544 10.93632z" fill="#00cc00" p-id="3533"></path></svg>
        <p style="color: #0c0;">Run</p>
      </div>
      <div class="legenditem">
        <svg t="1672910618198" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3532" id="mx_n_1672910618201" data-spm-anchor-id="a313x.7781069.0.i2" width="32" height="90"><path d="M158.3104 589.824h707.3792a10.8544 10.8544 0 0 0 10.8544-10.8544v-133.98016a10.8544 10.8544 0 0 0-10.8544-10.8544H155.648a8.192 8.192 0 0 0-8.192 8.192v136.56064a10.8544 10.8544 0 0 0 10.8544 10.93632z" fill="#dbdbdb" p-id="3533"></path></svg>
        <p style="color: #dbdbdb;">OFF</p>
      </div>
      <div class="legenditem">
        <svg t="1672910618198" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3532" id="mx_n_1672910618201" data-spm-anchor-id="a313x.7781069.0.i2" width="32" height="90"><path d="M158.3104 589.824h707.3792a10.8544 10.8544 0 0 0 10.8544-10.8544v-133.98016a10.8544 10.8544 0 0 0-10.8544-10.8544H155.648a8.192 8.192 0 0 0-8.192 8.192v136.56064a10.8544 10.8544 0 0 0 10.8544 10.93632z" fill="#cc0000" p-id="3533"></path></svg>
        <p style="color: #c00;">Emergency</p>
      </div>
      <div class="legenditem">
        <svg t="1672910618198" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3532" id="mx_n_1672910618201" data-spm-anchor-id="a313x.7781069.0.i2" width="32" height="90"><path d="M158.3104 589.824h707.3792a10.8544 10.8544 0 0 0 10.8544-10.8544v-133.98016a10.8544 10.8544 0 0 0-10.8544-10.8544H155.648a8.192 8.192 0 0 0-8.192 8.192v136.56064a10.8544 10.8544 0 0 0 10.8544 10.93632z" fill="#ffa500" p-id="3533"></path></svg>
        <p style="color: #ffa500;">Manual</p>
      </div>
      <div class="legenditem">
        <svg t="1672910618198" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3532" id="mx_n_1672910618201" data-spm-anchor-id="a313x.7781069.0.i2" width="32" height="90"><path d="M158.3104 589.824h707.3792a10.8544 10.8544 0 0 0 10.8544-10.8544v-133.98016a10.8544 10.8544 0 0 0-10.8544-10.8544H155.648a8.192 8.192 0 0 0-8.192 8.192v136.56064a10.8544 10.8544 0 0 0 10.8544 10.93632z" fill="#1296db" p-id="3533"></path></svg>
        <p style="color: #1296db;">Wait</p>
      </div>
      <div class="void"></div>
    </div>


  </dir>
</template>

<script>
var myChart;
export default {
  name: 'BodeCharts',
  components: {
  },
  props: {
    gatt: Array,

  },
  data() {
    return {
      stateColor:{
        "OFF":"#dbdbdb",
        "EMERGENCY":"#c00",
        "WAIT":"#1296db",
        "AUTO_RUN":"#0c0",
        "AUTO_RUN_REMOTE":"#0c0",
        "MANUAL":"#ffa500",
        "MANUAL_EDIT":"#ffa500",
        "MANUAL_MDI":"#ffa500",
        "MANUAL_HANDLE":"#ffa500",
        "MANUAL_HANDLE_TCH":"#ffa500",
        "MANUAL_JOG":"#ffa500",
        "MANUAL_JOG_TCH":"#ffa500",
        "MANUAL_INC":"#ffa500",
        "MANUAL_REF":"#ffa500",
        "MANUAL_REMOTE":"#ffa500",
        "MANUAL_MSTR":"#ffa500",
        "NULL":"#515151"
      }
    }
  },
  methods: {

    
    renderItem(params, api) {
      const categoryIndex = api.value(0);
      const start = api.coord([api.value(1), categoryIndex]);
      const end = api.coord([api.value(2), categoryIndex]);
      const height = api.size([0, 1])[1] * 0.2;

      const rectShape = this.$echarts.graphic.clipRectByRect({
        x: start[0],
        y: start[1] - height / 2 - 70,
        width: end[0] - start[0],
        height: height + 130,
      }, {
        x: params.coordSys.x,
        y: params.coordSys.y,
        width: params.coordSys.width,
        height: params.coordSys.height
      });

      return rectShape && {
        type: 'rect',
        shape: rectShape,
        style: api.style()
      };
    },

    myEcharts() {

      var startTime = new Date();
      var dataCount = 10;
      var typess = [
        { name: 'Run', color: '#0c0' },   //1 
        { name: 'Stop', color: '#dbdbdb' }, //2
        { name: 'Idel', color: '#c00' }, //3
        { name: 'Error', color: '#ffa500' }, //4
        { name: 'Exception', color: '#1296db' }, //5
        { name: 'Exception2', color: '#85cddb' }, //5
      ];
      var ch = [0,0,0,1,0,2,0,3,4,0]
      var data2 = [];

        startTime.setHours(8)
        var baseTime = +startTime
        for (var i = 0; i < dataCount; i++) {
          var typeItem = typess[ch[i]];
          var duration = Math.round(Math.random() * 5600000);
          data2.push({
            name: typeItem.name,
            value: [1, baseTime, (baseTime += duration), duration],
            itemStyle: {
              normal: {
                color: typeItem.color
              }
            }
          });
          //baseTime += Math.round(Math.random() * 2000);
        }
        this.updateChart(data2)
    },
    update(index,gattList) {
      var data2 = [];
        for (var i = 0; i < gattList.length; i++) {
          console.log("******",gattList[i])
          var {starttime,result,endtime} = gattList[i];
          var duration = endtime-starttime;
          
          data2.push({
            name: result,
            value: [1, starttime, endtime, duration],
            itemStyle: {
              normal: {
                color:  this.stateColor[result]
              }
            }
          });
    
        }
        this.updateChart(data2)

    },
    updateChart(data2)
    {

      myChart = this.$echarts.init(document.getElementById('main'));
      var option = {
        tooltip: {
          formatter: function (params) {
            return params.marker + params.name + ': ' + (params.value[3] / 60000).toFixed(1) + ' min' + '(' + (params.value[3] / 60000 / 60).toFixed(1) + 'h)'
          }
        },
        grid: {
          top:10,
          bottom:0,
          height: 175
        },
        xAxis: {
          scale: true,
          type: 'time',
          axisLabel: {
            color: '#888'
          },
          axisLine:
          {
            lineStyle:
            {
              color: '#888'
            }
          }
        },
        yAxis: {
          data: [''],
          axisLabel: {
            color: '#888'
          },
          axisLine:
          {
            lineStyle:
            {
              color: '#888'
            }
          }
        },
        series: [
          {
            type: 'custom',
            renderItem: this.renderItem,
            itemStyle: {
              normal: {
                opacity: 0.8
              }
            },
            encode: {
              x: [1, 2],
              y: 0
            },
            data: data2
          }
        ]
      }

      myChart.setOption(option)
 
    }

  },
  mounted() {
    this.myEcharts()
  },
  watch: {
    'gatt': function(newVal){
      this.update(1,newVal)
    }
  }
}
</script>

<style lang="less">
.center-cmp {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-direction: column;

  .cc-header {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
  }

  .cc-details {
    height: 120px;
    display: flex;
    justify-content: center;
    font-size: 32px;
    align-items: center;

    .card {
      background-color: rgba(4, 49, 128, .6);
      color: #08e5ff;
      height: 70px;
      width: 70px;
      font-size: 45px;
      font-weight: bold;
      line-height: 70px;
      text-align: center;
      margin: 10px;
    }
  }

  .cc-main-container {
    position: relative;
    flex: 1;
    display: flex;

    .ccmc-middle {
      width: 50%;
      height: 90%;

      .active-ring-name {
        font-size: 20px !important;
      }
    }

    .ccmc-left,
    .ccmc-right {
      width: 25%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 24px;

      span {
        font-size: 40px;
        font-weight: bold;
      }

      .station-info {
        height: 80px;
        display: flex;
        align-items: center;
      }
    }

    .ccmc-left {
      align-items: flex-end;

      span {
        margin-left: 20px;
      }
    }

    .ccmc-right {
      align-items: flex-start;

      span {
        margin-right: 20px;
      }
    }
  }

  .label-tag {
    position: absolute;
    width: 500px;
    height: 30px;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
  }




  
  .card-footer {
    height: 25%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .card-footer-item {
    padding: 5px 10px 0px 10px;
    box-sizing: border-box;
    width: 40%;
    background-color: rgba(6, 30, 93, 0.7);
    border-radius: 3px;

    .footer-title {
      font-size: 15px;
      margin-bottom: 5px;
    }

    .footer-detail {
      font-size: 20px;
      color: #1294fb;
      display: flex;
      font-size: 18px;
      align-items: center;

      .dv-digital-flop {
        margin-right: 5px;
      }
    }
  }
}
.legend{
  display: grid;
  grid-template-columns: 10% repeat(5,1fr) 10%;
}
.legenditem{
  font-size: 25px;
  display: flex;
  justify-content: center;
}
</style>
